import {priority} from '@priority-software/priority-proto-api/lib';
import {isHour12Format, isTime} from '../../../utils/time';
import {formatDate, isDateTime} from '../../../utils/date';

export const has12AMPMFormat = (dateTime: string) => {
    const value = dateTime.toUpperCase();
    return value.includes('AM') || value.includes('PM');
};

export const autocompleteWithQuestionMarks = (
    currentValue: string,
    columnType: priority.netitems.form.ColumnType,
    lang: string
): string => {
    const is12Hour = isHour12Format(lang);
    const timeQuestionMarks = is12Hour ? '??:?? ??' : '??:??';

    // For Time-only fields (Time5)
    if (isTime(columnType) && !isDateTime(columnType)) {
        if (!currentValue || currentValue.trim() === '') {
            return timeQuestionMarks;
        }
        // Partial value like "12:" → "12:??"
        if (currentValue.includes(':')) {
            const [hours, minutes] = currentValue.split(' ')[0].split(':');
            const hasAmPm = has12AMPMFormat(currentValue);
            if (is12Hour && !hasAmPm) {
                return minutes ? `${hours}:${minutes} ??` : `${hours}:?? ??`;
            }
            return minutes ? currentValue : `${hours}:??`;
        }
        return `${currentValue}:??`;
    }

    // For DateTime fields (Date14)
    if (isDateTime(columnType)) {
        if (!currentValue || currentValue.trim() === '') {
            // Use existing formatDate to get current date
            const today = new Date();
            const dateStr = formatDate(today, priority.netitems.form.ColumnType.Date10);
            return `${dateStr} ${timeQuestionMarks}`;
        }

        const parts = currentValue.split(' ');
        const datePart = parts[0] || '';
        const timePart = parts.slice(1).join(' ');

        if (!timePart || timePart.trim() === '') {
            return `${datePart} ${timeQuestionMarks}`;
        }

        // Partial time
        if (timePart.includes(':')) {
            const [hours, minutes] = timePart.split(':');
            const hasAmPm = has12AMPMFormat(currentValue);

            if (is12Hour && !hasAmPm) {
                return `${datePart} ${hours}:${minutes || '??'} ??`;
            }
            return `${datePart} ${hours}:${minutes || '??'}`;
        }

        return `${datePart} ${timePart}:??`;
    }

    return currentValue;
};
